<template>
<b-card>
  <template #header>
    <h5 class="card-title">Mengapa Menggunakan Jasa Kami</h5>
  </template>
  <div class="d-flex align-items-center">
    <template v-if="showContent">
      <b-form-checkbox @change="$emit('updateShowSection', $event, 'home-why-choose-us', apiGet)" id="preview" value="Y" unchecked-value="N" name="preview" v-model="showContent">Show Section?</b-form-checkbox>
    </template>

    <b-button variant="secondary" class="btn-rounded ml-auto" v-if="previewOpen" @click="closePreviewForm">
      Close <i class="fas fa-times ml-2"></i>
    </b-button>
    <b-button variant="outline-info" class="btn-rounded ml-auto" @click="showPreviewUpdate" v-else>
      Update Content <i class="fas fa-pencil-alt ml-2"></i>
    </b-button>

  </div>
  <hr />

  <validation-observer v-slot="{ handleSubmit }" ref="VFormDescription" tag="div" v-if="previewOpen">
    <b-form @submit.prevent="handleSubmit(doSubmitDesc)">
      <b-card class="border mb-0">
        <template #header>
          <h5 class="card-title">Content</h5>
        </template>
        <b-row class="mb-2">
          <b-col md=4>
            <div class="form-group">
              <label class="control-label">Title <span class="text-danger">*</span></label>
              <b-form-input v-model="row.asc_title" />
              <VValidate name="Title" v-model="row.asc_title" rules="required|min:3|max:160" />
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md=4>
            <div class="form-group">
              <label class="control-label">Description</label>
              <b-form-textarea :rows="3" v-model="row.asc_content" />
              <VValidate name="Description" v-model="row.asc_content" rules="min:3" />
            </div>
          </b-col>
        </b-row>
        <template #footer>
          <div class="text-right">
            <b-button variant="secondary" class="btn-rounded mr-3" @click="closePreviewForm">Cancel</b-button>
            <button type="submit" class="btn btn-info btn-rounded">Save Changes</button>
          </div>
        </template>
      </b-card>
    </b-form>
  </validation-observer>

  <template v-else>
    <div class="row justify-content-center">
      <div class="col-md-8 text-center">
        <h3>{{row.asc_title}}</h3>
        <div class="sect-heading__line"></div>
        <p>{{row.asc_content}}</p>
      </div>
    </div>

    <b-row>
      <b-col lg="4" v-for="(v, k) in jasa" :key="`jasa${k}`">
        <div class="why_choose_us_wrap p-2 h-100">
          <div class="ic_wrap position-relative text-center">
            <img :src="parent.uploader(v.image)" alt="" title="">

            <div class="bullet-cta">
              <b-button type="button" @click="openModal('modalJasa', {...v, keyData: k})" variant="warning" class="btn-icon mr-0 rounded-pill" v-b-tooltip.hover title="Ubah Keunggulan">
                <i class="ti-pencil"></i>
              </b-button>
              <b-button @click="doDelete(v)" type="button" variant="danger" class="btn-icon mt-1 mr-0 rounded-pill" v-b-tooltip.hover title="Hapus Keunggulan">
                <i class="ti-trash"></i>
              </b-button>
            </div>
          </div>
          <div class="desc_wrap text-center mt-2">
            <h3 class="pb-0 font-weight-bold mt-2">{{ v.title }}</h3>
            <p class="mb-0">{{ v.description }}</p>
          </div>
        </div>
      </b-col>

      <b-col lg="12" class="mt-3">
        <div class="text-center">
          <b-button variant="outline-primary" class="rounded-pill" @click="openModal('modalJasa')"><i class="ti-plus"></i> Add Jasa</b-button>
        </div>
      </b-col>
    </b-row>

    <b-modal id="modalJasa" :title="(jasaRow.typeLabel == 'Added' ? 'Add' : 'Update') + ' How We Work'" size="md">
      <validation-observer v-slot="{ handleSubmit }" ref="VFormJasa">
        <b-form @submit.prevent="handleSubmit(doSubmit)">

          <b-row>
            <b-col md=12>
							<div class="form-group">
								<label class="control-label">Image <span class="text-danger">*</span></label>         
								<Uploader v-model="jasaRow.image" type="icon_keunggulan"/>
								<VValidate 
									name="Image" 
									v-model="jasaRow.image"
									:rules="{required: 1}" 
								/>
							</div>
						</b-col>
            <b-col md=12>
              <div class="form-group mb-2">
                <label class="control-label">Title <span class="text-danger">*</span></label>
                <input type="text" class="form-control" placeholder="Title" v-model="jasaRow.title">
                <VValidate name="Title" v-model="jasaRow.title" :rules="{required: true, min: 3, regex:/^[^\s]+(\s+[^\s]+)*$/}" />
              </div>
            </b-col>
            <b-col md=12>
              <div class="form-group mb-2">
                <label class="control-label">Description <span class="text-danger">*</span></label>
                <b-form-textarea :rows="3" v-model="jasaRow.description"></b-form-textarea>
                <VValidate name="Description" v-model="jasaRow.description" :rules="{ required: true, min: 3 }" />
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <template #modal-footer="{close}">
        <div class="text-right">
          <b-button class="btn-rounded" variant="outline-secondary" @click="close">Cancel</b-button>
          <b-button type="button" @click="doSubmit" class="btn-rounded ml-2" variant="primary">Save Changes</b-button>

        </div>
      </template>
    </b-modal>
  </template>

</b-card>
</template>

<script>
import Gen from '@/libs/Gen.js'
// let _ = global._

export default {
  components: {},
  props: {
    modulePage: String
  },
  data() {
    return {
      previewOpen: false,
      jasaRow: {},
      row: {},
      jasa: [],
      configCKEditor: ['heading', '|', 'bold', 'italic', 'underline', 'strikethrough', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
      validation: {},
      showCompanyBrief: false,
      showContent: null
    }
  },
  computed: {
    parent() {
      return this.$parent.$parent.$parent
    }
  },
  mounted() {
    this.apiGet()
  },
  methods: {
    showPreviewUpdate() {
      this.previewOpen = true
    },
    closePreviewForm() {
      this.previewOpen = false
    },
    openModal(modal, data = null) {
      this.$bvModal.show(modal)

      this.$set(this, 'jasaRow', {
        typeLabel: 'Added'
      })
      if (data) this.$set(this, 'jasaRow', {
        ...this.jasaRow,
        ...data,
        typeLabel: 'Updated'
      })
    },
    doDelete(data){
      this.$swal.fire({
        title: "Do You Really Want to Delete This Data",
        text: "Data that has been deleted can't recover anymore.",
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, Delete Data",
        cancelButtonText: "No, Cancel",
      }).then(button => {
        if(button.isConfirmed){
          this.parent.swalLoading()
          let jasa = this.jasa.filter(dtJasa => dtJasa.title != data.title)

          Gen.apiRest('/do/' + this.modulePage, 
              { data: { type: 'updateJasa', ac_value: jasa, type_label: "Deleted" } }
            ).then(res => {
              if(res){
                this.$swal({
                  title: res.data.message,
                  icon: 'success',
                }).then(() => {
                  this.$bvModal.hide('modalJasa')
                  this.apiGet()
                })
              }
            }).catch(err => {
              this.$swal({title: err.response.data.message, icon:'error'})
            })
        }
      })
    },
    doSubmit() {
      this.$refs.VFormJasa.validate().then(success => {
        if (!success) return

        this.parent.swalLoading()
        let jasa

        if (!this.jasa.length) {
          jasa = [{
            ...this.jasaRow,
            typeLabel: null
          }]
        } else {
          if (this.jasaRow.typeLabel == "Updated") {
            jasa = this.jasa.map((dtJasa, kJasa) => {
              if (kJasa == this.jasaRow.keyData) return {
                ...this.jasaRow,
                keyData: null
              }
              return dtJasa
            })
          } else {
            jasa = [...this.jasa, {
              ...this.jasaRow,
              typeLabel: null
            }]
          }
        }

        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateJasa',
            ac_value: jasa,
            type_label: this.jasaRow.typeLabel
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.$bvModal.hide('modalJasa')
              this.apiGet()
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },
    doSubmitDesc() {
      this.$refs.VFormDescription.validate().then(success => {
        if (!success) return

        this.parent.swalLoading()

        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateJasaDescription',
            ...this.row
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.closePreviewForm()
              this.apiGet()
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },
    apiGet() {
      Gen.apiRest('/get/' + this.modulePage + '/why_choose_us', {}, 'GET').then(res => {
        this.row = res.data.row
        this.jasa = res.data.jasa
        this.validation = res.data.validation
        this.showContent = res.data.showContent
      })
    }
  }
}
</script>

<style scoped>
.why_choose_us_wrap{
  box-shadow: 0 0 10px 0 rgba(22, 24, 27, 0.2) !important;
  -webkit-box-shadow: 0 0 10px 0 rgb(183 192 206 / 20%) !important;
}

.cta--arrow {
  padding-right: 56px !important;
}

.cta--secondary {
  background-color: #F7C832 !important;
  border-color: #F7C832 !important;
}

.cta {
  font-size: 14px !important;
  border-radius: 5px !important;
  text-transform: uppercase !important;
  padding: 10px 28px !important;
  border: 1px solid transparent !important;
  color: #000 !important;
  background-color: transparent;
  display: inline-block !important;
  font-weight: 622300 !important;
  font-weight: 700 !important;
  position: relative !important;
  transition: 0.25s ease-in-out !important;
}

.cta--arrow i {
  position: absolute !important;
  top: -1px !important;
  right: -1px !important;
  bottom: -1px !important;
  width: 40px !important;
  border-radius: 5px !important;
  background-color: rgba(0, 0, 0, .125) !important;
  display: block !important;
  text-align: center !important;
  line-height: 46px !important;
  font-size: 18px !important;
  transition: 0.25s ease-in-out !important;
}
</style>